import { render } from "./StartAggregationModal2.vue?vue&type=template&id=568f352c&scoped=true"
import script from "./StartAggregationModal2.vue?vue&type=script&lang=js"
export * from "./StartAggregationModal2.vue?vue&type=script&lang=js"

import "./StartAggregationModal2.vue?vue&type=style&index=0&id=568f352c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568f352c"]])

export default __exports__